import React, { Fragment } from 'react';
import styled from 'styled-components';

import ToggleableButton from './ToggleableButton';
import { useToggleableList } from './methods';
import { colors } from './constant';
import { FilterSplitLine } from './other-components';

const ToggleButtons = ({ options, value, setValue }) => {

    const [ list ,handleListItemClick, checkListItemExist, resetList ] = useToggleableList(value, setValue);
    const isAll = list.length <= 0;

    return (
        <>
            <Button as={ToggleableButton}
                value={isAll}
                setValue={() => resetList()}
            >全部</Button>

            <FilterSplitLine/>

            { options.map((item, index) => <Fragment key={index}> { item &&
                <Button as={ToggleableButton}
                    value={checkListItemExist(item)}
                    setValue={() => handleListItemClick(item)}
                >{ item }</Button>
            } </Fragment> )}
        </>
    )
}

const Button = styled.button`
`

export default ToggleButtons
